function ChangelogPage() {
    return (
        <>Changelog</>
    );
}

export default ChangelogPage;